import {CreatePortalProps} from "./createPortalTypes";
import { createPortal } from 'react-dom';

const CreatePortal = (props: CreatePortalProps) => {
    return createPortal(props.children, props.mount);
};

export default CreatePortal;